import { render, staticRenderFns } from "./FeaturedNumbers.vue?vue&type=template&id=8b3982c6&scoped=true&"
import script from "./FeaturedNumbers.vue?vue&type=script&lang=js&"
export * from "./FeaturedNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3982c6",
  null
  
)

export default component.exports